export default "<app-map-core #map [options]=\"mapOptions\"></app-map-core>\n"